"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));
var _react = _interopRequireWildcard(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Tooltip = _interopRequireDefault(require("./Tooltip"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "dynamic_data_table-module__container___XBKGO",
  "table": "dynamic_data_table-module__table___KPe4Z",
  "header": "dynamic_data_table-module__header___InOJk",
  "hidden_scroll": "dynamic_data_table-module__hidden_scroll___smZMg",
  "cell": "dynamic_data_table-module__cell___WmECs",
  "title": "dynamic_data_table-module__title___xRq1r",
  "body": "dynamic_data_table-module__body____WpZz",
  "wrapper": "dynamic_data_table-module__wrapper___6vpz9",
  "inner": "dynamic_data_table-module__inner___DWRAj",
  "row": "dynamic_data_table-module__row___mJOCH",
  "even": "dynamic_data_table-module__even___s9yJX dynamic_data_table-module__row___mJOCH",
  "odd": "dynamic_data_table-module__odd___QReWF dynamic_data_table-module__row___mJOCH",
  "sortable": "dynamic_data_table-module__sortable___y8wPA",
  "no_wrap": "dynamic_data_table-module__no_wrap___hv7Wl",
  "custom_no_data": "dynamic_data_table-module__custom_no_data___qSxqC",
  "msg": "dynamic_data_table-module__msg___dAka6",
  "msg_icon": "dynamic_data_table-module__msg_icon___CBpqN",
  "no_rows": "dynamic_data_table-module__no_rows___DABRw dynamic_data_table-module__msg___dAka6",
  "fetching": "dynamic_data_table-module__fetching___Udqx5 dynamic_data_table-module__msg___dAka6",
  "ellipsis": "dynamic_data_table-module__ellipsis___GMwo_",
  "highlight": "dynamic_data_table-module__highlight___VP4U1",
  "actions": "dynamic_data_table-module__actions___geMKG",
  "tooltip": "dynamic_data_table-module__tooltip___iNmbQ",
  "copy": "dynamic_data_table-module__copy___ua22X"
};
const getStyles = style => {
  const grow = style?.flexGrow ?? 0;
  const shrink = style?.flexShrink ?? 1;
  const basis = style?.width ? style?.width + 'px' : 'auto';
  const result = {
    flex: `${grow} ${shrink} ${basis}`
  };
  if (style?.minWidth) {
    result.minWidth = style.minWidth;
  }
  if (style?.maxWidth) {
    result.maxWidth = style.maxWidth;
  }
  if (style?.textAlign) {
    result.textAlign = style.textAlign;
  }
  if (style?.justifyContent) {
    result.justifyContent = style.justifyContent;
  }
  if (style?.wordWrap) {
    result.wordWrap = style.wordWrap;
  }
  return result;
};
const Cell = /*#__PURE__*/_react.default.memo(props => {
  const [showTooltip, setShowTooltip] = (0, _react.useState)(false);
  const cellRef = (0, _react.useRef)();
  const {
    style,
    className,
    tooltipRef,
    children,
    ...cellProps
  } = props;
  const classes = (0, _classnames.default)([styles.cell, {
    [styles.no_wrap]: !style.wordWrap
  }, className]);
  const onMouseEnter = e => {
    const cell = cellRef.current;
    let tagList = (0, _from.default)(cell.querySelectorAll('[data-tcl="AuTags-value"]'));
    const overflow = tag => tag.offsetWidth < tag.scrollWidth;
    if (cell && !showTooltip && (cell.offsetWidth < cell.scrollWidth || (0, _some.default)(tagList).call(tagList, overflow))) {
      setShowTooltip(true);
    }
  };
  const onMouseLeave = e => {
    if (showTooltip) {
      setShowTooltip(false);
    }
  };
  const getTooltipOffset = () => {
    const cellEl = cellRef.current;
    const rowEl = cellEl.closest(`.${styles.row}`);
    const gridEl = rowEl.closest(`.${styles.inner}`);
    const offsetLeft = cellEl.offsetLeft - 1; // border width
    const minWidth = offsetLeft + cellEl.scrollWidth + 114; // 114 = copy button space

    let adjustment = 0;
    // if there is not enough space on the right, adjust to the left
    if (minWidth > rowEl.offsetWidth) {
      adjustment = minWidth - rowEl.offsetWidth;
    }
    return {
      top: rowEl.offsetTop + (0, _parseInt2.default)(gridEl.getAttribute('data-offsety'), 10),
      left: offsetLeft - adjustment
    };
  };
  cellProps.ref = cellRef;
  cellProps.className = classes;
  cellProps.onMouseLeave = onMouseLeave;
  cellProps.onMouseEnter = onMouseEnter;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, cellProps, {
    style: getStyles(style)
  }), children, showTooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    style: {
      ...getTooltipOffset(),
      maxHeight: cellRef.current.offsetHeight
    },
    data: cellRef.current.innerText,
    containerRef: tooltipRef
  }, children));
});
Cell.propTypes = {
  tooltipRef: T.object,
  className: T.string,
  style: T.object
};
var _default = exports.default = Cell;